@reference "@glow/tailwind-config/reference.css";

.bar {
  @apply flex;
  @apply flex-row;
  @apply fixed;
  @apply left-0;
  @apply right-0;
  @apply bg-white;
  @apply shadow-02;
  @apply h-[72px];
  @apply pr-6;
}

.status {
  @apply flex;
  @apply items-center;
  @apply bg-gray-100;
  @apply px-7;
  @apply text-base;
  @apply text-gray-600;
  @apply flex-nowrap;
  @apply whitespace-nowrap;
}

.secondary-action-menu .action-bar-action .inner-content {
  @apply font-normal;
  @apply text-black;
}
.secondary-action-menu .action-bar-action:hover {
  @apply bg-gray-100;
  @apply shadow-gray-500;
  @apply rounded-sm;
}

.actions {
  @apply flex;
  @apply pl-4;
  @apply gap-2;
  @apply min-w-0;
  @apply flex-1;
}

.actionsInner {
  @apply flex;
  @apply items-center;
  @apply flex-1;
  @apply gap-2;
  @apply overflow-hidden;
  @apply pl-1;
  @apply max-w-full;
  @apply min-w-0;
}

.secondaryActions {
  @apply flex;
  @apply items-center;
  @apply pl-6;
  @apply min-w-0;
}

.divider {
  @apply bg-gray-200;
  @apply w-[1px];
  @apply h-10;
  @apply mr-4;
}

.action {
  @apply flex;
  @apply items-center;
  @apply border-transparent;
  @apply cursor-pointer;
  @apply bg-transparent;
  @apply text-primary-500;
  @apply text-sm;
  @apply font-semibold;
  @apply flex-nowrap;
  @apply whitespace-nowrap;
  @apply p-0;
  @apply pr-4;
  @apply rounded-xs;
  @apply h-10;
}

.action:not([disabled]):hover {
  @apply bg-gray-100;
  @apply shadow-gray-500;
  @apply rounded-sm;
}

.actionIcon {
  @apply flex;
  @apply items-center;
  @apply justify-center;
  @apply w-10;
  @apply h-10;
}

.disabled {
  @apply opacity-30;
  @apply cursor-default;
}
